module.exports = __webpack_public_path__ + "img/access_2.f05beb8d.jpg";